import { braidService as r } from "@waitroom/braid";
import { httpService as a } from "@waitroom/http-client";
import { config as d } from "../config.es.js";
import { buildApiParamsWithAuth as i, buildApiParams as g } from "../helpers.es.js";
const n = "/integrations", o = `${n}/salesforce`, c = `${n}/hubspot`, p = {
  getProviders: async (t) => a.get(await g(`${n}/providers`, t)),
  getConnections: async (t) => a.get(await i(`${n}/connections`, t)),
  getAction: async (t, e, s) => a.get(await i(`${n}/${t}/${e}`, s)),
  callAction: async (t, e, s) => a.post(await i(`${n}/${t}/${e}`, s)),
  getFromAbsoluteURL: async (t, e) => a.get(await i("", { url: t, ...e })),
  postToAbsoluteURL: async (t, e) => a.post(await i("", { url: t, ...e })),
  absoluteURL: async (t, e, s) => a.request(await i("", { url: e, method: t, ...s })),
  authorize: async (t) => a.get(await i(`${n}/authorize`, t)),
  disconnect: async (t) => a.delete(await i(`${n}/disconnect`, t)),
  getBindingsByOwnerSessionRecurrencePerProvider: async (t, e, s) => r.fetch(
    await i(
      `${n}/-/get-bindings-by-owner-session-recurrence-per-provider`,
      {
        ...s,
        ...d.defaultBraidParams,
        params: {
          sessionId: t,
          sessionRecurrenceId: e
        }
      }
    )
  ),
  // Salesforce
  salesforce: {
    createBinding: async (t) => a.post(await i(`${o}/bindings`, t)),
    deleteBinding: async (t, e) => a.delete(
      await i(`${o}/bindings/${t}`, e)
    ),
    getAccountById: async (t, e) => a.get(await i(`${o}/accounts/${t}`, e)),
    getOpportunityById: async (t, e) => a.get(
      await i(`${o}/opportunities/${t}`, e)
    ),
    listBindableRecordsAsOptions: async (t) => a.get(
      await i(
        `${o}/-/list-bindable-records-as-options`,
        t
      )
    ),
    createContact: async (t, e) => a.post(
      await i(`${o}/contacts`, {
        data: t,
        ...e
      })
    ),
    getContacts: async (t, e, s) => a.get(
      await i(`${o}/contacts/-/list-related-to-record`, {
        params: {
          ...s == null ? void 0 : s.params,
          recordId: t,
          recordType: e
        },
        ...s
      })
    ),
    getLeadById: async (t, e) => a.get(await i(`${o}/leads/${t}`, e))
  },
  // Hubspot
  hubspot: {
    createBinding: async (t) => a.post(await i(`${c}/bindings`, t)),
    deleteBinding: async (t, e) => a.delete(await i(`${c}/bindings/${t}`, e)),
    getCompanyById: async (t, e) => a.get(await i(`${c}/companies/${t}`, e)),
    getDealById: async (t, e) => a.get(await i(`${c}/deals/${t}`, e)),
    listBindableRecordsAsOptions: async (t) => a.get(
      await i(
        `${c}/-/list-bindable-records-as-options`,
        t
      )
    ),
    getContacts: async (t, e, s) => a.get(
      await i(`${c}/contacts/-/list-related-to-record`, {
        params: {
          ...s == null ? void 0 : s.params,
          recordId: t,
          recordType: e
        },
        ...s
      })
    ),
    getContactById: async (t, e) => a.get(await i(`${c}/contacts/${t}`, e))
  }
};
export {
  p as integrationsApiService
};
